import { Component, effect, input, linkedSignal, output, untracked } from '@angular/core';
import {
  SwitchBar,
  SwitchBarOption,
  Select,
  Skeleton,
  SimpleDialog,
  SimpleDialogLayout,
  Button,
} from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { LocationNamePipe } from '../../../locations/pipes/location-name-pipe';
import { form, FormField } from '@angular/forms/signals';
import { ConsumptionFilter, isFilterEqual } from '../../stores/consumption.store';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  EnergyInterfaceResponse,
  LocationResponse,
} from '../../../../core/clients/omni-core/models';

@Component({
  selector: 'app-analysis-consumption-filters',
  imports: [
    SwitchBar,
    SwitchBarOption,
    NgIcon,
    Select,
    Skeleton,
    LocationNamePipe,
    FormField,
    NgTemplateOutlet,
    SimpleDialog,
    SimpleDialogLayout,
    Button,
    TranslocoPipe,
    NgClass,
  ],
  templateUrl: './analysis-consumption-filters.html',
})
export class AnalysisConsumptionFilters {
  filter = input.required<ConsumptionFilter>();

  showLocationsSelect = input(true);
  locationsLoading = input(false);
  locations = input<LocationResponse[] | null>(null);

  energyInterfacesLoading = input.required<boolean>();
  energyInterfaces = input.required<EnergyInterfaceResponse[]>();

  changeFilter = output<ConsumptionFilter>();

  private model = linkedSignal(this.filter);
  protected form = form(this.model);

  constructor() {
    // clear location and/or energy-interface input if their values are not available anymore
    effect(() => {
      const energyInterfacesLoading = this.energyInterfacesLoading();
      const energyInterfaces = this.energyInterfaces();
      const locationsLoading = this.locationsLoading();
      const locations = this.locations();
      const showLocationsSelect = this.showLocationsSelect();

      const filter = untracked(this.filter);
      const energyInterfaceID = filter.data.energyInterfaceID
        ? energyInterfaces.some((e) => e.id === filter.data.energyInterfaceID) ||
          energyInterfacesLoading
          ? filter.data.energyInterfaceID
          : ''
        : '';

      const locationID = filter.data.locationID
        ? locations?.some((l) => l.id === filter.data.locationID) ||
          locationsLoading ||
          !showLocationsSelect
          ? filter.data.locationID
          : ''
        : '';

      const updatedFilter = {
        ...filter,
        data: {
          ...filter.data,
          energyInterfaceID,
          locationID,
        },
      };

      if (isFilterEqual(filter, updatedFilter)) {
        return;
      }

      this.changeFilter.emit(updatedFilter);
    });
  }

  protected async onChangeFilter() {
    await new Promise((resolve) => setTimeout(resolve, 0));
    this.changeFilter.emit(this.model());
  }
}
